import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import AgentNavbar from "../../component/AgentNavbar";
import { baseurl } from "../../component/Baseurl";
import { Plus, Star, MapPin, CheckSquare } from "react-feather";
import { FaStar, FaRegStar } from "react-icons/fa";
// Import Swiper modules
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ChevronsDown } from "react-feather"; 
import HotelSlider from "./AgentComp/HotelSlider";
import HotelRoomList from "./AgentComp/HotelRoomList";

function HotelDetail() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hotelToken = queryParams.get("hotelToken");

  const [hotelData, setHotelData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null); // State to manage selected image

  useEffect(() => {
    if (hotelToken) {
      axios
        .post(`${baseurl}hoteldetails`, { hotelToken })
        .then((response) => {
          console.log("API Response:", response.data);
          const hotelInfo =
            response.data?.HotelDetails?.HotelInfoResult?.HotelDetails;
          setHotelData(hotelInfo);
          if (hotelInfo?.Images?.length > 0) {
            setSelectedImage(hotelInfo.Images[0]); // Set first image as default
          }
        })
        .catch((error) => {
          console.error("Error fetching hotel details:", error);
        });
    }
  }, [hotelToken]);

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle missing dates
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };



  // const agentid = localStorage.getItem("agent_id");

  const agentid = localStorage.getItem("agent_id") || '2';

  console.log("agent id",agentid );
  const [hotelMarkup, setHotelMarkup] = useState(0); // Initialize with 0


  
  useEffect(() => {
    if (!agentid) return console.error("No agent ID found in localStorage");
  
    const fetchMarkupDetails = async () => {
      try {
        const { data } = await axios.get(`${baseurl}getMarkupDetailsById/${agentid}`);
  
        if (data?.message === "Markup details fetched successfully") {
          const admin_hotel_markup = Number(data.adminMarkup.admin_hotel_markup) || 0;
          const distributor_hotel_markup = Number(data.distributorMarkup.distributor_hotel_markup) || 0;
          const hotel_markup_amount = Number(data.agentMarkup.hotel_markup_amount) || 0;
  
          const totalMarkup = admin_hotel_markup + distributor_hotel_markup + hotel_markup_amount;
  
          console.log("Hotel Markup Amount:", totalMarkup);
          setHotelMarkup(totalMarkup); // Update state correctly
        } else {
          console.error("Unexpected API response", data);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    fetchMarkupDetails();
  }, [agentid]);


  return (
    <>
      <AgentNavbar />

      <div className="container-fluid py-4 secbg1">
        {hotelData ? (
          <div>
            <div className="row">
              {/* Main Image Section */}
              <div className="col-md-12">
                <HotelSlider images={hotelData.Images} />

                <div className="row"></div>

                <div className="container my-5">
                  <div className="row">
                    <div className="col-md-8 bg-white p-3 rounded border">
                      <div
                        className="d-flex justify-content-between"
                        style={{ width: "100%" }}
                      >
                        <div>
                          <h1 className="text-start htlname">
                            {hotelData.HotelName}
                          </h1>
                          <p className="text-start">
                            <MapPin size={17} />
                            &nbsp;{hotelData.Address}
                          </p>
                        </div>
                        <div className="ms-auto">
                          <div className="p-2 rounded">
                            <div className="ratingc">
                              {hotelData.StarRating}{" "}
                              <FaStar size={20} color="white" />
                            </div>

                            <div className="bgtwo pb-1">
                              {hotelData.StarRating
                                ? [...Array(5)].map((_, index) =>
                                    index < hotelData.StarRating ? (
                                      <FaStar
                                        key={index}
                                        size={16}
                                        color="#d82f5e"
                                      />
                                    ) : (
                                      <FaRegStar
                                        key={index}
                                        size={16}
                                        color="#d82f5e"
                                      />
                                    )
                                  )
                                : "No Rating"}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="mt-3">
                          <p className="ptxt">{hotelData.Description}</p>
                        </div>

                        {hotelData?.Amenities?.length > 0 && (
                          <div>
                            <h1 className="text-start dlgwqi">Amenities</h1>
                            <ul className="row">
                              {hotelData.Amenities.map((amenity, index) => (
                                <li
                                  className="col-md-6 text-start litm"
                                  key={index}
                                >
                                  <CheckSquare size={14} />
                                  &nbsp;{amenity}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {hotelData?.Landmarks?.length > 0 && (
                          <div>
                            <h1 className="text-start dlgwqi">Landmarks</h1>
                            <ul className="row">
                              {hotelData.Landmarks.map((landmark, index) => (
                                <li
                                  key={index}
                                  className="col-md-6 text-start litm"
                                >
                                  <CheckSquare size={14} />
                                  &nbsp;{landmark.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {hotelData.Latitude && hotelData.Longitude && (
                          <div className="mt-3">
                            <iframe
                              width="100%"
                              height="300"
                              frameBorder="0"
                              style={{ border: 0 }}
                              src={`https://www.google.com/maps?q=${hotelData.Latitude},${hotelData.Longitude}&output=embed`}
                              allowFullScreen
                            ></iframe>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="box_prie bg-white">
                        <div className="sum1 w100 p-3 text-white text-center">
                          <div className="text-center">
                            Hotel Room Booking Summary
                          </div>
                        </div>
                        <div className="mysum">
                          <div className="border rounded p-2 mb-3">
                            <div className="text-start romname mb-1">
                              {hotelData.first_room_details.room_name}
                            </div>

                            <div className="mb-1 text-start">
                              <div className="d-flex justify-content-between w100">
                                <span className="romdate">Check-In</span>{" "}
                                <span className="romdate1 ms-auto">
                                  {hotelData.checkin}
                                  {/* {formatDate(hotelData.checkin)} */}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between w100">
                                <span className="romdate">Check-Out</span>{" "}
                                <span className="romdate1 ms-auto">
                                {hotelData.checkout}
                                  {/* {formatDate(hotelData.checkout)} */}
                                </span>
                              </div>

                              <div className="d-flex justify-content-between w100">
                                <span className="romdate">
                                  Cancellation Available Till
                                </span>{" "}
                                <span className="romdate1 ms-auto">
                                  {formatDate(hotelData.first_rm_cancel_date)}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="text-dark text-start mb-3">
                            <span className="prc1">
                              {hotelData.first_room_details.Price
                                .CurrencyCode === "INR"
                                ? "₹"
                                : hotelData.first_room_details.Price
                                    .CurrencyCode}
                            </span>
                            &nbsp;
                            <span className="offerprice">
                            {(Number(hotelData.first_room_details.Price.OfferedPriceRoundedOff) || 0) + hotelMarkup}

                              {/* {hotelData.first_room_details.Price.OfferedPrice}  */}
                              {/* /Night */}
                            </span>
                            &nbsp;&nbsp;
                            <span className="mrp1">
                              M.R.P.: &nbsp;
                              {hotelData.first_room_details.Price.CurrencyCode}
                              
                            </span>
                            -&nbsp;
                            <span className="mrp1">
                              {/* {hotelData.first_room_details.Price.PublishedPrice} */}
                              {(Number(hotelData.first_room_details.Price.PublishedPrice) || 0) + hotelMarkup}
                            </span>
                          </div>

                          {/* <div className="text-dark text-start">
                            <span className="tax1">
                              Tax.: &nbsp;
                              {hotelData.first_room_details.Price.CurrencyCode}
                            </span>
                            -&nbsp;
                            <span className="tax1">
                              {hotelData.first_room_details.Price.Tax}
                            </span>
                          </div> */}

                          <div>
                            <a href="#rooms" className="bookallbtn w-100">
                              <strong>
                                View All Available Rooms{" "}
                                <ChevronsDown size={16} />
                              </strong>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 
<div>

<div>
<h1 className="text-start htlname">Hotel Policy</h1> 
<p>{hotelData?.HotelInfoResult?.HotelPolicy}</p>


</div>


</div> */}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center vh-100  text-white">
            <span className="loader1">
              <span className="text-white"></span>
            </span>
          </div>
        )}

        <div id="rooms" className="py-2">
          <HotelRoomList hotelMarkup={hotelMarkup} />
        </div>
      </div>
    </>
  );
}

export default HotelDetail;
